import { createDataModule } from '@perpay-web/data-module/createDataModule';
import {
    fetchCardAccountApplication,
    fetchCardAccountApplicationSuccess,
    fetchCardAccountApplicationError,
    fetchCardAccountApplicationReset,
} from '@perpay-web/fintech/actions/entities/cardAccountApplications';
import { REJECTED } from '@perpay-web/fintech/constants/cardAccountApplicationStatuses';

const FetchCardAccountApplicationDataModule = createDataModule({
    dataRequest: fetchCardAccountApplication,
    dataSuccess: fetchCardAccountApplicationSuccess,
    dataError: fetchCardAccountApplicationError,
    dataReset: fetchCardAccountApplicationReset,
});

const getRootFetchCardAccountApplication = (state) =>
    state.dataModules.fetchCardAccountApplication;
const initialValueFetchCardAccountApplication = {};

export const fetchCardAccountApplicationDataModule =
    FetchCardAccountApplicationDataModule({
        getRoot: getRootFetchCardAccountApplication,
        initialValue: initialValueFetchCardAccountApplication,
    });

export const getMaterial = (state) =>
    fetchCardAccountApplicationDataModule.getData(state).material || '';

export const getPassedIdv = (state) => {
    const data = fetchCardAccountApplicationDataModule.getData(state);
    return data.passedIdv !== undefined ? data.passedIdv : null;
};

export const getMarketplaceSpendingLimit = (state) => {
    const data = fetchCardAccountApplicationDataModule.getData(state);
    return data.marketplaceSpendingLimit !== undefined &&
        data.status === REJECTED
        ? data.marketplaceSpendingLimit
        : null;
};
